import { render, staticRenderFns } from "./DbcdP_List.vue?vue&type=template&id=29582e3c"
import script from "./DbcdP_List.vue?vue&type=script&lang=js"
export * from "./DbcdP_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports